module.exports = __webpack_public_path__ + "img/review-success.679768fb.png";